import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Eye = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.04 12.32a1.01 1.01 0 0 1 0-.64 10.5 10.5 0 0 1 19.92 0 1 1 0 0 1 0 .64 10.5 10.5 0 0 1-19.92 0z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
  </svg>
));
